import styled from "styled-components";
import MuiModal from "@material-ui/core/Modal";

export const Modal = styled(MuiModal)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  position: absolute;
  width: 328px;
  margin: 10px 0 64px;
  padding: 14px 12px 2px;
  border-radius: 5px;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.25);
  background-color: ${({ theme }) => theme.backgroundColor};
  outline: none;
`;

export const Title = styled.div`
  margin: 10px 28px 16px 12px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.04;
  letter-spacing: normal;
  color: ${({ theme }) => theme.onBackgroundColor};
`;

export const Body = styled.div`
  margin: 16px 12px 0;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.onBackgroundColor};
`;

export const Button = styled.div`
  margin-left: 24px;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  text-transform: uppercase;
  margin: 14px 0 0 12px;
  padding: 14px 8px;
  color: ${({ theme }) => theme.visitedLink};
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Options = styled.div`
  display: grid;
  row-gap: 24px;
  margin-top: 24px;
`;
export const Row = styled.div`
  display: flex;
`;
